module.exports = __webpack_public_path__ + "static/6-a1fd8dbfdb07ddf0e61418f9c75cc9bc.jpeg";